/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { OverrideInAction } from './overrideInAction';
import type { OverrideInScope } from './overrideInScope';

export interface OverrideIn {
  action: OverrideInAction;
  scope?: OverrideInScope;
}
